/* eslint-disable css-modules/no-unused-class, camelcase  */
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserAchievements } from '@queries/platform/achievements';
import { selectUserUuid } from '@redux/slices/userSlice';
import Achievements from './achievements';

const AchievementsExpandedContainer: FC<AchievementsContainerProps> = (props: AchievementsContainerProps) => {
    const { showLeaderboard, fullWidth } = props;
    const userUuid = useSelector(selectUserUuid);
    const { data: userAchievementsData, isLoading: isUserAchievementsLoading } = useGetUserAchievements(userUuid);
    const [userCoins, setUserCoins] = useState<number>(0);
    const [userBadges, setUserBadges] = useState<string[]>([]);

    useEffect(() => {
        if (!userAchievementsData || userAchievementsData?.user_badges === undefined) return;
        const { user_badges, user_points } = userAchievementsData;
        setUserCoins(user_points);
        setUserBadges(user_badges);
    }, [userAchievementsData]);

    return (
        <Achievements
            showLeaderboard={showLeaderboard}
            fullWidth={fullWidth}
            userDevCoins={userCoins}
            activityBadges={userBadges}
            isLoading={isUserAchievementsLoading}
        />
    );
};
interface AchievementsContainerProps {
    showLeaderboard: boolean;
    fullWidth: boolean;
}
export default AchievementsExpandedContainer;
